import styled from "styled-components";

import { colorsPalettes, rgba, setFontVariant } from "@similarweb/styles";
import { FlexRow } from "@similarweb/ui-components";

export const StyledSignalsManagementSectionContainer = styled.div<{ noPaddingBottom?: boolean }>`
    background-color: ${colorsPalettes.carbon[0]};
    padding: ${(p) => `27px 27px ${p.noPaddingBottom ? 0 : 27}px 27px`};
    margin-bottom: 32px;
    border-radius: 6px;
    box-shadow: 0 3px 6px 0 ${rgba(colorsPalettes.carbon[500], 0.08)};
`;

export const StyledSignalsManagementSectionTitle = styled.div`
    display: flex;
    ${setFontVariant("h5", colorsPalettes.carbon[500])};
`;

export const StyledSignalsManagementSectionSubTitle = styled.div`
    display: flex;
    ${setFontVariant("body2", colorsPalettes.carbon[400])};
`;

export const StyledSignalsManagementSectionHeader = styled(FlexRow)`
    padding-bottom: 24px;
    justify-content: space-between;
    border-bottom: 1px solid ${colorsPalettes.carbon[50]};
`;

export const StyledSignalsManagementSectionFooter = styled.div`
    display: flex;
    justify-content: flex-end;
    padding-top: 16px;
`;